import { type FC } from 'react';
import { useDispatch } from 'react-redux';
import { mapInfoUpdateRequest } from '~/store/mapInfo/mapInfo.actionCreators';
import {
  useIsConnectedLayeredMapSelector,
  useMapInfoDataSelector, useMapInfoUpdateErrorsSelector,
} from '~/store/mapInfo/mapInfo.selectors';
import { useClientIdSelector } from '~/store/selectors/useClientIdSelector';
import { useMapIdSelector } from '~/store/selectors/useMapIdSelector';
import { SaveMapInfoComponent } from './saveMapInfo.component';

export const SaveMapInfoContainer: FC = () => {
  const mapInfoData = useMapInfoDataSelector();
  const mapName = mapInfoData?.name ?? '';
  const mapDescription = mapInfoData?.description || null;
  const isLayeredMapConnected = useIsConnectedLayeredMapSelector();
  const mapId = useMapIdSelector() ?? null;
  const clientId = useClientIdSelector();
  const errors = useMapInfoUpdateErrorsSelector();
  const mapInfo = useMapInfoDataSelector();

  const dispatch = useDispatch();

  const updateMapName = (name: string) => {
    if (clientId === null || mapId === null || mapName === name) {
      return;
    }

    dispatch(mapInfoUpdateRequest(clientId, mapId, {
      name,
    }));
  };

  const updateMapDescription = (description: string) => {
    if (clientId === null || mapId === null || mapDescription === description) {
      return;
    }

    dispatch(mapInfoUpdateRequest(clientId, mapId, {
      description,
    }));
  };

  return (
    <SaveMapInfoComponent
      errors={errors}
      isMapLayered={isLayeredMapConnected}
      isSnapshot={!!mapInfo?.parentMap}
      mapDescription={mapDescription}
      mapName={mapName}
      onDescriptionUpdate={updateMapDescription}
      onNameUpdate={updateMapName}
    />
  );
};
